import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5f0f4e59"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/youtube/yt-html.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/assets/css/youtube/yt-live-chat-renderer.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "@/assets/css/youtube/yt-live-chat-item-list-renderer.css?vue&type=style&index=2&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports